import Blue from '~/core'

new Blue({
  name: 'iframeBlock',
  selector: '.iframe-block',
  setup(iframeBlock) {
    const container = iframeBlock.querySelector('.iframe-block__container')
    const loader = iframeBlock.querySelector('.iframe-block__loader')
    const ifrm = iframeBlock.querySelector('.iframe-block__container iframe')

    ifrm.addEventListener('load', (event) => {
      if (loader) {
        loader.style.display = 'none'
      }
      // ifrm.style.visibility = 'hidden';
      // ifrm.style.height = "10px";
      //ifrm.style.visibility = 'visible';
      ifrm.classList.add('is-loaded')
      let doc = ifrm.contentDocument ? ifrm.contentDocument : ifrm.contentWindow.document
      ifrm.style.height = getDocHeight(doc) + 50 + 'px'
    })

    function getDocHeight(doc) {
      doc = doc || document
      var body = doc.body,
        html = doc.documentElement
      var height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      )

      return height
    }
  },
})
